import React, { useEffect, useState } from "react";
import NewHeader from "../../directives/NewHeader";
import { Col, Container, Row } from "react-bootstrap";
import "../../Styles/NewHowitworks.css";
import Footer from "../../directives/footer";
import DownloadSection from "./DownloadSection";
import Marquee from 'react-fast-marquee';
import HowItWorksMetaTag from "../MetaTags/HowItWorksMetaTag";
const NewHowItWorks = () => {

  const [news, setNews] = useState([]); // Fixed useState syntax

  useEffect(() => {
    // Example data, replace this with API call or dynamic data
    setNews([
      "Download The App Now",
      "Download The App Now",
      "Download The App Now",
      "Download The App Now",
      "Download The App Now",
      "Download The App Now",
    ]);
  }, []);



  return (
    <>
      <div className="position-fixed w-100 " style={{ zIndex: 999 }}>
        <NewHeader />
        <HowItWorksMetaTag />

      </div>
      <div className="top-shelf-start"></div>
      <div className="position-relative">
        <div className="cp1"></div>
        <div className="cp2"></div>
        <div className="cp3"></div>
        <div className="cp4"></div>
        <div className="cp5"></div>

        <div className="new-hiw-svg1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="258"
            height="497"
            viewBox="0 0 258 497"
            fill="none"
          >
            <path
              className="animated-path"
              d="M100.622 9.94492C152.669 38.3194 196.072 82.327 223.749 134.775C241.77 168.931 275.634 251.289 211.814 261.032C182.031 265.579 99.0188 227.355 77.3073 223.737C36.7962 216.999 20.2472 259.846 24.4758 296.235C30.1901 345.465 66.4465 373.487 102.012 402.97C118.167 416.361 136.798 428.201 157.688 430.358C178.564 432.509 201.864 422.492 209.494 402.933C219.271 377.929 197.598 348.373 171.108 344.164C144.619 339.954 118.014 355.979 102.668 377.997C89.8184 396.445 82.9032 419.244 66.4103 434.53C34.9075 463.726 -13.028 454.027 -51.9357 455.876C-80.8044 457.254 -111.778 464.777 -130 487.231"
              stroke="url(#paint0_linear_173_2147)"
              stroke-opacity="0.3"
              stroke-width="18"
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <defs>
              <linearGradient
                id="paint0_linear_173_2147"
                x1="499.04"
                y1="295.471"
                x2="59.0377"
                y2="695.275"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#41D2FF" />
                <stop offset="0.474" stop-color="#7E42FF" />
                <stop offset="0.9619" stop-color="#DD3FFF" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div className="new-hiw-svg2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="242"
            height="499"
            viewBox="0 0 242 499"
            fill="none"
          >
            <path
              className="animated-path"
              d="M415.74 58.2583C365.913 26.1454 306.498 9.10467 247.201 9.91166C208.586 10.4405 120.066 20.1324 142.063 80.8288C152.328 109.155 225.626 163.74 239.195 181.07C264.504 213.413 234.807 248.453 200.834 262.16C154.875 280.709 112.917 262.291 70.0066 245.178C50.5165 237.405 31.2021 226.715 19.3083 209.407C7.42667 192.108 5.06723 166.856 18.5874 150.794C35.86 130.24 72.1845 135.12 88.5609 156.363C104.937 177.605 103.604 208.634 91.6178 232.648C81.5726 252.761 64.8656 269.746 59.3395 291.544C48.7868 333.179 80.2491 370.622 97.25 405.668C109.86 431.673 118.082 462.469 107.09 489.216"
              stroke="url(#paint0_linear_173_2146)"
              stroke-opacity="0.5"
              stroke-width="18"
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <defs>
              <linearGradient
                id="paint0_linear_173_2146"
                x1="-25.6681"
                y1="-154.864"
                x2="-166.06"
                y2="422.835"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#41D2FF" />
                <stop offset="0.474" stop-color="#7E42FF" />
                <stop offset="0.9619" stop-color="#DD3FFF" />
              </linearGradient>
            </defs>
          </svg>
        </div>

        <Container>
          <Row>
            <Col lg={7} className="d-flex flex-column justify-content-center">
              <div>
                <p className="new-hiw-header">
                  HOW STEPMINT <span className="new-hiw-subheader">WORKS</span>
                </p>
                <p className="new-hiw-text sofia-sans">
                  Earn Step Rewards. <br />
                  Just by Walking. Seriously.
                </p>
              </div>
            </Col>
            <Col lg={5}>
              <div className="position-relative">
                <img src="assets\images\newdesign\hero01.png" className="img-fluid" alt="" />
                <img
                 
                  src="assets\images\newdesign\newlogo2.png"
                  className="img-fluid float-logo"
                  alt=""
                />
              </div>
            </Col>
          </Row>
        </Container>
        <div className="new-hiw-clip " style={{ overflow: "hidden" }}>
        <Marquee direction="left">
                {news.map((item, index) => (
                  <div key={index} className="d-flex align-items-center">
                    <img src="assets/images/bubblegum.svg" className="mx-3" alt="" />
                    <h3 className="text-uppercase mb-0 fw-semibold fst-italic text-nowrap">
                      {item}
                    </h3>
                  </div>
                ))}
              </Marquee>
        </div>
        <br />
        <br />
        <br />
        {/* <Container>
            <div className="new-hiw-div2 text-center p-4">
                <p className="new-hiw-div2header">Introducing 
                 <span className="new-hiw-div2subheader"> Stepmint</span>
                </p>
                <p className='text-center text-capitalize'>our Path to Earning Crypto with Every Step!</p>
                <br />
                <p className='text-center w-75' style={{fontSize:18}}>STEPMINT is more than just a step tracking app; it's a Web 3.0-powered revolution that rewards you for leading an active lifestyle.</p>
            </div>
           </Container> */}

        <Container>
          <div className="new-aboutus-01  ">
            <h3 className="new-aboutus-01-backheader">STEPMINT</h3>
            <p
              className="new-aboutus-01-header sofia-sans"
              style={{ fontWeight: 600, fontSize: 32 }}
            >
              {" "}
              <span className="new-hiw-div2subheader sofia-sans"> Stepmint</span> Step By
              Step Process
            </p>
          </div>
          <div className="d-flex flex-column gap-3">
            <Row className="gy-3">
              <Col lg={8} className="d-flex align-items-center">
                <div>
                  <p className="hiw-card-header sofia-sans">Download the App</p>
                  <p className="hiw-card-para sofia-sans">
                    Start by grabbing the Stepmint app on iOS or Android. Sign
                    up in seconds and unlock your new lifestyle — where every
                    step earns.
                  </p>
                </div>
              </Col>
              <Col lg={4}>
                <div>
                  <img
                    className="img-fluid p-4"
                    src="assets\images\newdesign\hiwcard01.svg"
                    alt=""
                  />
                </div>
              </Col>
            </Row>
            <Row className="gy-3 flex-row-reverse">
              <Col lg={8} className="d-flex align-items-center">
                <div>
                  <p className="hiw-card-header">Track Every Step</p>
                  <p className="hiw-card-para">
                    Phone in your pocket? Stepmint syncs up and counts it all
                    with pinpoint accuracy. Your hustle is now measurable — and
                    profitable.
                  </p>
                </div>
              </Col>
              <Col lg={4}>
                <div>
                  <img
                    className="img-fluid p-4"
                    src="assets\images\newdesign\hiwcard02.svg"
                    alt=""
                  />
                </div>
              </Col>
            </Row>
            <Row className="gy-3 ">
              <Col lg={8} className="d-flex align-items-center">
                <div>
                  <p className="hiw-card-header">Earn Rewards Effortlessly</p>
                  <p className="hiw-card-para">
                    No workouts required. Just walk. Your steps automatically
                    generate step rewards throughout the day.
                  </p>
                </div>
              </Col>
              <Col lg={4}>
                <div>
                  <img
                    className="img-fluid p-4"
                    src="assets\images\newdesign\hiwcard003.svg"
                    alt=""
                  />
                </div>
              </Col>
            </Row>
            <Row className="gy-3 flex-row-reverse">
              <Col lg={8} className="d-flex align-items-center">
                <div>
                  <p className="hiw-card-header">Crush Daily Step Goals</p>
                  <p className="hiw-card-para">
                    We help you set realistic goals — then cheer you on as you
                    smash them.
                  </p>
                </div>
              </Col>
              <Col lg={4}>
                <div>
                  <img
                    className="img-fluid p-4"
                    src="assets\images\newdesign\hiwcard004.svg"
                    alt=""
                  />
                </div>
              </Col>
            </Row>
            {/* <Row className='gy-3'>
    <Col lg={8} className='d-flex align-items-center'>
    <div>
        <p className="hiw-card-header">Secure and Transparent Rewards</p>
        <p className="hiw-card-para">Your crypto assets are securely stored, and the rewards system operates on a transparent and decentralized blockchain network. You can monitor your earnings with confidence.</p>
       
    </div>
    </Col>
    <Col lg={4}>
    <div>
        <img className='img-fluid p-4' src="assets\images\newdesign\hiwcard05.svg" alt="" />
    </div>
    </Col>
</Row> */}
          </div>
        </Container>
        <br />
        <br />
        <div className="position-relative">
          <div className="new-hiw-svg3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="258"
              height="297"
              viewBox="0 0 258 497"
              fill="none"
            >
              <path
                className="animated-path"
                d="M100.622 9.94492C152.669 38.3194 196.072 82.327 223.749 134.775C241.77 168.931 275.634 251.289 211.814 261.032C182.031 265.579 99.0188 227.355 77.3073 223.737C36.7962 216.999 20.2472 259.846 24.4758 296.235C30.1901 345.465 66.4465 373.487 102.012 402.97C118.167 416.361 136.798 428.201 157.688 430.358C178.564 432.509 201.864 422.492 209.494 402.933C219.271 377.929 197.598 348.373 171.108 344.164C144.619 339.954 118.014 355.979 102.668 377.997C89.8184 396.445 82.9032 419.244 66.4103 434.53C34.9075 463.726 -13.028 454.027 -51.9357 455.876C-80.8044 457.254 -111.778 464.777 -130 487.231"
                stroke="url(#paint0_linear_173_2147)"
                stroke-opacity="0.3"
                stroke-width="18"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_173_2147"
                  x1="499.04"
                  y1="295.471"
                  x2="59.0377"
                  y2="695.275"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#41D2FF" />
                  <stop offset="0.474" stop-color="#7E42FF" />
                  <stop offset="0.9619" stop-color="#DD3FFF" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div className="new-hiw-svg4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="142"
              height="299"
              viewBox="0 0 242 499"
              fill="none"
            >
              <path
                className="animated-path"
                d="M415.74 58.2583C365.913 26.1454 306.498 9.10467 247.201 9.91166C208.586 10.4405 120.066 20.1324 142.063 80.8288C152.328 109.155 225.626 163.74 239.195 181.07C264.504 213.413 234.807 248.453 200.834 262.16C154.875 280.709 112.917 262.291 70.0066 245.178C50.5165 237.405 31.2021 226.715 19.3083 209.407C7.42667 192.108 5.06723 166.856 18.5874 150.794C35.86 130.24 72.1845 135.12 88.5609 156.363C104.937 177.605 103.604 208.634 91.6178 232.648C81.5726 252.761 64.8656 269.746 59.3395 291.544C48.7868 333.179 80.2491 370.622 97.25 405.668C109.86 431.673 118.082 462.469 107.09 489.216"
                stroke="url(#paint0_linear_173_2146)"
                stroke-opacity="0.5"
                stroke-width="18"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_173_2146"
                  x1="-25.6681"
                  y1="-154.864"
                  x2="-166.06"
                  y2="422.835"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#41D2FF" />
                  <stop offset="0.474" stop-color="#7E42FF" />
                  <stop offset="0.9619" stop-color="#DD3FFF" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div className="hiw-last-div ">
            <Container className="py-5 text-center">
              <p className="mb-0" style={{ fontSize: 18, fontWeight: 600 }}>
                Download STEPMINT today, start tracking your steps and earn
                rewards
              </p>
            </Container>
          </div>
        </div>
        <br />
        <br />
      </div>
      {/* SECTION 7 */}

      <DownloadSection />
      {/* SECTION 8 */}

      <Footer />
    </>
  );
};

export default NewHowItWorks;
